// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3QjQW","copyrightBlock":"footer-module--copyright-block--3NDFe"};